module.exports = __webpack_public_path__ + "img/e9c3e65.svg";